module.exports = __webpack_public_path__ + "assets/img/ic_favorite_2_full.12997266.svg";